/** searchs through all arrays of the tree if the for a value from a property
 * @param aTree : the tree array
 * @param fCompair : This function will receive each node. It's upon you to define which
                     condition is necessary for the match. It must return true if the condition is matched. Example:
                        function(oNode){ if(oNode["Name"] === "AA") return true; }
 * @param bGreedy? : us true to do not stop after the first match, default is false
 * @return an array with references to the nodes for which fCompair was true; In case no node was found an empty array
 *         will be returned
*/
export var _searchTree = function (aTree, fCompair, bGreedy) {
  var aInnerTree = [] // will contain the inner children
  var oNode // always the current node
  var aReturnNodes = [] // the nodes array which will returned

  // 1. loop through all root nodes so we don't touch the tree structure
  for (var keysTree in aTree) {
    aInnerTree.push(aTree[keysTree])
  }
  while (aInnerTree.length > 0) {
    oNode = aInnerTree.pop()
    // check current node
    if (fCompair(oNode)) {
      aReturnNodes.push(oNode)
      if (!bGreedy) {
        return aReturnNodes
      }
    } else { // if (node.children && node.children.length) {
      // find other objects, 1. check all properties of the node if they are arrays
      for (var keysNode in oNode) {
        // true if the property is an array
        if (oNode[keysNode] instanceof Array) {
          // 2. push all array object to aInnerTree to search in those later
          for (var i = 0; i < oNode[keysNode].length; i++) {
            aInnerTree.push(oNode[keysNode][i])
          }
        }
      }
    }
  }
  return aReturnNodes // someone was greedy
}

export function findParent (element, parentID) {
  if (element.NODE_ID === parentID) {
    return element
  } else if (element.children) {
    if (element.children.length > 0) {
      var i
      var result = null
      for (i = 0; result == null && i < element.children.length; i++) {
        result = findParent(element.children[i], parentID)
      }
      return result
    }
  }
  return null
}
export function findNode (element, searchID) {
  if (element.NODE_ID === searchID) {
    return element
  } else if (element.children) {
    if (element.children.length > 0) {
      var i
      var result = null
      for (i = 0; result == null && i < element.children.length; i++) {
        result = findParent(element.children[i], searchID)
      }
      return result
    }
  }
  return null
}
